import React, { useEffect, useState } from 'react';
import { Button, Grid, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, Radio, RadioGroup, FormControlLabel, TextField, Typography, List, ListItem, ListItemText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getMonthNameById } from '../services/MyCollections';


export default function CustomPopup({ open, handleClose, handleConfirm, title, message, actionType, isSimple = false, netPrice, month, year, clients }) {
  const [step, setStep] = useState(0);
  const [additionalActivity, setAdditionalActivity] = useState('no');
  const [isVATPayer, setIsVATPayer] = useState(false);
  const [additionalActivityDescription, setAdditionalActivityDescription] = useState('');
  const [additionalActivityAmount, setAdditionalActivityAmount] = useState('');
  const [files, setFiles] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [invoiceFile1, setInvoiceFile1] = useState(null);
  const [invoiceFile2, setInvoiceFile2] = useState(null);

  // State for declarationChecklist checklist (step 1)
  const [declarationChecklist, setDeclarationChecklist] = useState({
    vatDeclaration: '',
    citAdvance: '',
    pitAdvance: '',
    salaries: '',
    draDeclaration: '',
    accountingDocs: '',
    paymentInfo: '',
    clientDocs: ''
  });

  const validateStep = () => {

    if (step === 1) {
      // Check if all checklist items have been answered
      if (!Object.values(declarationChecklist).every((value) => value === true)) {
        alert(`Wszystkie odpowiedzi powinny być zaznaczone jako "tak"`);
        return false;
      }
    }
    if (step === 2) {
      if (additionalActivity !== 'no' && (!additionalActivityDescription || !additionalActivityAmount)) {
        alert("Uzupełnij poprawnie wszystkie pola");
        return false;
      }
      if (additionalActivity === 'additionalWork' && !uploadedFile) {
        alert("Plik z wyliczeniami jest wymagany.");
        return false;
      }
    }

    if (step === 3) {
      // Dodaj walidację dla plików faktur na kroku 2
      if (!invoiceFile1 || (additionalActivity === 'additionalWork' && !invoiceFile2)) {
        alert("Pliki faktur są wymagane.");
        return false;
      }
    }

    return true;
  };

  const handleNext = () => {
    if (validateStep()) {
      // Tylko jeśli walidacja przejdzie pomyślnie, przejdź do następnego kroku
      setStep(step + 1);
    }
  };

  const handleBack = () => setStep((prev) => prev - 1);

  const localHandleConfirm = () => {
    if (!isSimple) {
      if (validateStep()) {
        const additionalWorkDTO =
          (additionalActivity === 'additionalWork' || additionalActivity === 'corrections') && {
            isAdditionalWorkAdded: true,
            additionalWorkDescription: additionalActivityDescription,
            additionalWorkAmount: additionalActivityAmount,
            additionalWorkTypeId: additionalActivity === 'additionalWork' ? 1 : 11
          };

        const additionalData = {
          ...(additionalWorkDTO && { additionalWorkDTO }),
          isVATPayer,
          isDeclarationSent: true,
        };

        handleConfirm("sendDeclaration", additionalData, files);
      }
    } else {
      handleConfirm(actionType);
    }
  };

  useEffect(() => {
    if (!isSimple) {
      setStep(0);
      setAdditionalActivity('no');
      setIsVATPayer(false);
      setAdditionalActivityDescription('');
      setAdditionalActivityAmount('');
      setFiles([]);
      setUploadedFile(null);
      setInvoiceFile1(null);
      setInvoiceFile2(null);
      setDeclarationChecklist({
        vatDeclaration: '',
        citAdvance: '',
        pitAdvance: '',
        salaries: '',
        draDeclaration: '',
        accountingDocs: '',
        paymentInfo: '',
        clientDocs: ''
      });
    }
  }, [open]);

  const handleFileChange = (event, fileType) => {
    const newFile = event.target.files[0];

    if (newFile) {
      //Sprawdzamy rozmiar pliku (limit: 2 MB)
      const maxFileSize = 2 * 1024 * 1024; // 2 MB w bajtach
      if (newFile.size > maxFileSize) {
        alert("Plik jest za duży. Maksymalny rozmiar to 2 MB.");
        return; // Przerwanie funkcji, jeśli plik jest za duży
      }
      // Tworzymy nowy obiekt zawierający oryginalny plik i jego typ
      const fileWithMetadata = { file: newFile, fileType };

      if (fileType === 1) {
        setUploadedFile(fileWithMetadata);
      } else if (fileType === 11) {
        setInvoiceFile1(fileWithMetadata);
      } else {
        setInvoiceFile2(fileWithMetadata);
      }

      // Aktualizujemy listę plików w stanie
      setFiles((prevFiles) => {
        // Usuwamy plik o tym samym typie, jeśli istnieje
        const filteredFiles = prevFiles.filter((file) => file.fileType !== fileType);
        // Dodajemy nowy plik do przefiltrowanej listy
        return [...filteredFiles, fileWithMetadata];
      });
    }
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setAdditionalActivity(value);

    const updatedFiles = files.filter(fileObj => fileObj.fileType !== 1 && fileObj.fileType !== 21);
    setAdditionalActivityDescription('');
    setAdditionalActivityAmount('');
    setFiles(updatedFiles);
    setUploadedFile(null);
    setInvoiceFile2(null);
  };

  const handleRadioChange2 = (event) => {
    const { name, value } = event.target;
    setDeclarationChecklist((prev) => ({
      ...prev,
      [name]: value === 'true', // Konwersja wartości na typ boolean
    }));
  };

  if (isSimple) {
    // Prosty popup
    return (
      <Dialog 
        open={open} 
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose();
          }
        }} 
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title" 
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
            <Box sx={{ m: '20px' }} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Anuluj
          </Button>
          <Button color="primary" onClick={localHandleConfirm} variant="contained">
            Zatwierdź
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  // Wieloetapowy formularz
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
      disableEscapeKeyDown
      aria-labelledby="popup-title"
      sx={{ '& .MuiDialog-paper': { width: '80%', maxWidth: '700px' } }} // Ustawia szerokość na 80% ekranu, z maksymalną szerokością 600px
    >
      <DialogTitle id="popup-title">
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
          <Grid item xs={10} style={{ textAlign: 'left', marginTop: 2 }}>
            {step > 0 ? `Wysyłanie zestawienia - Krok ${step} z 3` : ""}
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'right', marginTop: -6 }}>
            <IconButton onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>

        {step === 0 && (
          <>
            <Typography style={{ textAlign: 'center' }}>
              <strong>Dziękujemy!</strong> Twoje zestawienie miesięczne zostało wysłane do 7PM.
              <br /><br />
              Superwizor sprawdzi i zatwierdzi je do wypłaty w ciągu <strong>9 dni kalendarzowych</strong> od otrzymania faktury.
              <br /><br />
              Przejdź przez kolejne kroki, aby dokończyć formalności rozliczeniowe niezbędne do wypłaty wynagrodzenia oraz wgrać fakturę.
            </Typography>
          </>
        )}
        {step === 1 && (
          <>
            <Typography>
              <strong>
                Oświadczam, że w oparciu o otrzymane dowody księgowe rozliczane za m-c {getMonthNameById(month)} {year}, prowadziłam/em rzetelnie i zgodnie z obowiązującymi przepisami prawa księgi rachunkowe powierzonych mi podmiotów:
              </strong>
              <Box
                sx={{
                  maxHeight: 100, // ustaw wysokość na tyle, ile potrzebujesz
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '8px',
                  marginTop: '8px',
                }}
              >
                <List>
                  {clients.map((client, index) => (
                    <ListItem key={index} sx={{ padding: 0 }}>
                      <ListItemText primary={`${index + 1}. ${client}`} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Typography>
            <Box sx={{ m: '20px' }} />
            <Box mt={1}>
              <Typography variant="body1"><strong>Deklaruję, że we wszystkich wymaganych prawem przypadkach:</strong></Typography>
              <Box sx={{ m: '10px' }} />
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
                {[
                  { label: 'deklaracje VAT-7 (7K, 9M, UE, inne) zostały sporządzone i wysłane w terminie (UPO)', name: 'vatDeclaration' },
                  { label: 'zaliczki CIT-8 (CIT-8K, CIT-8E, inne) zostały naliczone', name: 'citAdvance' },
                  { label: 'zaliczki PIT-4 zostały naliczone', name: 'pitAdvance' },
                  { label: 'wynagrodzenia zostały naliczone', name: 'salaries' },
                  { label: 'deklaracje DRA ZUS zostały sporządzone i wysłane w terminie', name: 'draDeclaration' },
                  { label: 'dokumenty księgowe zostały wprowadzone i zadekretowane (dokumenty sprzedaży, dokumenty kosztowe, wyciągi bankowe, wynagrodzenia, amortyzacja)', name: 'accountingDocs' },
                  { label: 'informacje o rozliczeniach podatkowych i ZUS zostały przekazane klientom w terminie', name: 'paymentInfo' },
                  { label: 'wszystkie dokumenty udostępnione przez klientów znajdują się na dedykowanym dysku, w katalogu rozliczanego okresu', name: 'clientDocs' }
                ].map((item, index) => (
                  <li key={index} style={{ marginBottom: '1em' }}> {/* Dodany odstęp po każdym punkcie */}
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item xs={9}>
                        <Typography variant="body2">{item.label}</Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <RadioGroup row name={item.name} value={declarationChecklist[item.name]} onChange={handleRadioChange2}>
                          <FormControlLabel value={true} control={<Radio />} label="tak" />
                          <FormControlLabel value={false} control={<Radio />} label="nie" />
                        </RadioGroup>
                      </Grid>
                    </Grid>
                  </li>
                ))}
              </ul>
            </Box>
          </>
        )}
        {step === 2 && (
          <>
            <Typography gutterBottom>
              Czy oprócz ujętych w zestawieniu prac na łączną kwotę <strong>{netPrice} PLN</strong> wykonałaś/wykonałeś jakieś dodatkowe prace uzgodnione z 7PM, które chcesz doliczyć do bieżącego zestawienia, lub odliczyć jakieś korekty?
            </Typography>
            <RadioGroup
              row
              value={additionalActivity}
              onChange={handleRadioChange}
            >
              <FormControlLabel value="no" control={<Radio />} label="nie" />
              <FormControlLabel value="additionalWork" control={<Radio />} label="dodatkowe prace" />
              <FormControlLabel value="corrections" control={<Radio />} label="korekty" />
            </RadioGroup>

            {additionalActivity === 'additionalWork' && (
              <Box mt={2}>
                <TextField
                  label="Jakie prace?"
                  placeholder="skrócony opis"
                  fullWidth
                  margin="normal"
                  value={additionalActivityDescription}
                  inputProps={{
                    maxLength: 100,
                  }}
                  onChange={(e) => setAdditionalActivityDescription(e.target.value)}
                />
                <TextField
                  label="Kwota za dodatkowe prace (bez VAT)"
                  placeholder="0.00"
                  fullWidth
                  margin="normal"
                  value={additionalActivityAmount}
                  onChange={(e) => setAdditionalActivityAmount(e.target.value)}
                  type="number"
                />

                <Button
                  variant="contained"
                  color="success"
                  component="label"
                  fullWidth
                  sx={{ mt: 2 }}
                >
                  Wgraj arkusz z dokładnymi wyliczeniami/opisem
                  <input type="file" hidden onChange={(e) => handleFileChange(e, 1)} />
                </Button>

                {uploadedFile && (
                  <Typography mt={1}>
                    <strong>Wgrano plik: </strong>{uploadedFile.file.name}
                  </Typography>
                )}
              </Box>
            )}
            {additionalActivity === 'corrections' && (
              <Box mt={2}>
                <TextField
                  label="Czego dotyczy korekta?"
                  placeholder="skrócony opis"
                  fullWidth
                  margin="normal"
                  value={additionalActivityDescription}
                  inputProps={{
                    maxLength: 100,
                  }}
                  onChange={(e) => setAdditionalActivityDescription(e.target.value)}
                />
                <TextField
                  label="Kwota korekty"
                  placeholder="0.00"
                  fullWidth
                  margin="normal"
                  value={additionalActivityAmount}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Jeśli wartość jest dodatnia, zamień ją na wartość ujemną
                    const negativeValue = value > 0 ? -value : value;

                    setAdditionalActivityAmount(negativeValue);
                  }}
                  type="number"
                />
                <Button
                  variant="contained"
                  color="success"
                  component="label"
                  fullWidth
                  sx={{ mt: 2 }}
                >
                  Wgraj arkusz z wyliczeniami/opisem (opcjonalnie)
                  <input type="file" hidden onChange={(e) => handleFileChange(e, 1)} />
                </Button>

                {uploadedFile && (
                  <Typography mt={1}>
                    <strong>Wgrano plik: </strong>{uploadedFile.file.name}
                  </Typography>
                )}
              </Box>
            )}
          </>
        )}

        {step === 3 && (
          <>
            <Typography gutterBottom>Czy Twoja firma jest płatnikiem VAT?</Typography>
            <RadioGroup
              row
              value={isVATPayer}
              onChange={(e) => setIsVATPayer(e.target.value === 'true')}
            >
              <FormControlLabel value={false} control={<Radio />} label="nie" />
              <FormControlLabel value={true} control={<Radio />} label="tak" />
            </RadioGroup>

            <Box mt={2}>
              <Typography>
                {isVATPayer
                  ? `Wgraj fakturę na kwotę ${(netPrice * 1.23).toFixed(2)} zł brutto (${netPrice} zł netto) za usługi księgowe dot. okresu ${getMonthNameById(month)} ${year}`
                  : `Wgraj fakturę na kwotę ${netPrice} zł netto za usługi księgowe dot. okresu ${getMonthNameById(month)} ${year}`}
              </Typography>
              <Button
                variant="contained"
                color="success"
                component="label"
                fullWidth
                sx={{ mt: 1 }}
              >
                Wgraj
                <input type="file" hidden onChange={(e) => handleFileChange(e, 11)} />
              </Button>
              {invoiceFile1 && (
                <Typography mt={1}>
                  <strong>Wgrano plik: </strong>{invoiceFile1.file.name}
                </Typography>
              )}
              {additionalActivity === 'additionalWork' && (
                <>
                  <Typography sx={{ mt: 2 }}>
                    {isVATPayer
                      ? `Wgraj fakturę na kwotę ${(additionalActivityAmount * 1.23).toFixed(2)} zł brutto (${additionalActivityAmount} zł netto) za uzgodnione dodatkowe usługi księgowe`
                      : `Wgraj fakturę na kwotę ${additionalActivityAmount} zł netto za uzgodnione dodatkowe usługi księgowe`}

                  </Typography>
                  <Button
                    variant="contained"
                    color="success"
                    component="label"
                    fullWidth
                    sx={{ mt: 1 }}
                  >
                    Wgraj
                    <input type="file" hidden onChange={(e) => handleFileChange(e, 21)} />
                  </Button>
                  {invoiceFile2 && (
                    <Typography mt={1}>
                      <strong>Wgrano plik: </strong>{invoiceFile2.file.name}
                    </Typography>
                  )}
                </>
              )}
            </Box>
          </>
        )}
        {/* {step === 4 && (
          <>
            <Typography style={{ textAlign: 'center' }}>
              <strong>Dziękujemy</strong>, pliki zostały przesłane!
              <br /><br />
            </Typography>
          </>
        )} */}
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleClose} color="secondary" variant="outlined">
          Anuluj
        </Button> */}
        {step > 2 && (
          <Button onClick={handleBack} color="secondary" variant="outlined">
            {"< Poprzedni Krok"}
          </Button>
        )}
        {step < 3 ? (
          <Button onClick={handleNext} color="primary" variant="contained">
            {"Dalej >"}
          </Button>
        ) : (
          <Button onClick={localHandleConfirm} color="primary" variant="contained">
            Zatwierdź
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}